import { APPLICATION_CONFIG } from "@constants/constants";
import { partnerIdInstance } from "@utils/partner-id-instance";
import axios from "axios";
import qs from "qs";

import { attachAuthInterceptors } from "./session-refresh";

const instance = axios.create({
	baseURL: APPLICATION_CONFIG.url,
	paramsSerializer: (params) => {
		if (!params) return "";

		const filteredParams = Object.fromEntries(
			Object.entries(params).filter(
				([_, value]) => Boolean(value) !== false && value !== undefined,
			),
		);

		return qs.stringify(filteredParams, { arrayFormat: "repeat" });
	},
});

// The scoring service authorises partner-scoped requests against the partner's
// name, which it does not take from the id in the path — without it every one
// of them answers 403. Identity is where the name comes from, so it rides along
// from storage rather than through two hundred call sites.
instance.interceptors.request.use((config) => {
	const partnerName = partnerIdInstance.getPartnerName();

	if (partnerName) {
		config.params = { partner: partnerName, ...config.params };
	}

	return config;
});

attachAuthInterceptors(instance);

export const axiosInstance = instance;

export const request = {
	get: axiosInstance.get,
	post: axiosInstance.post,
	put: axiosInstance.put,
	patch: axiosInstance.patch,
	delete: axiosInstance.delete,
};
